import { render, staticRenderFns } from "./CreatePersonPortalModal.vue?vue&type=template&id=6eb25349&"
import script from "./CreatePersonPortalModal.vue?vue&type=script&lang=js&"
export * from "./CreatePersonPortalModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports